export default {
  all: [],
  loading: false
}
